// extracted by mini-css-extract-plugin
module.exports = {"Neighborhoods":"Neighborhoods_Neighborhoods__2jCn2","SmallMultiples":"Neighborhoods_SmallMultiples__15Zx7"};